import {
  SmartformFieldConfig,
  SmartformElement,
  ElementBase,
  ElementMetadata,
  ElementsMetadata,
  ElementWithMeta,
  SmartFormElements
} from '../types';
import { InputModel } from '../forms/utils';
import { filterNotEmpty } from '../forms/utils/listHelpers';

export function withDefaultFieldsAndMeta<Type extends string, Model = InputModel>(
  element: ElementBase | SmartformElement,
  formElements: SmartFormElements<Type, Model>
): ElementWithMeta<Model> {
  const staticElement = formElements.get(element.type as Type);
  const { fields } = element as SmartformElement;
  const userFields = Array.isArray(fields) ? fields : [];
  const requiredUserFields = userFields.filter(required);
  const requiredStaticMeta = staticElement?.meta.filter(required);
  const resultMeta: ElementsMetadata<Model> = [];

  const requiredFields =
    requiredStaticMeta?.map((m, index) => {
      resultMeta.push(m);
      return requiredUserFields[index] ?? m.defaultField;
    }) ?? [];

  const optionalFields = userFields
    .filter((el) => !!el.fieldName)
    .map((optional) => {
      const optionalMeta = staticElement?.meta.find((m) => m.fieldName === optional.fieldName);
      if (!optionalMeta) {
        return undefined;
      }
      resultMeta.push(optionalMeta);
      return {
        ...optionalMeta.defaultField,
        ...optional
      };
    })
    .filter((el) => !!el);

  return {
    ...element,
    fields: filterNotEmpty([...requiredFields, ...optionalFields]),
    meta: resultMeta
  };
}

function required(field: SmartformFieldConfig | ElementMetadata<any>): boolean {
  return !field.fieldName;
}
